module.exports = __webpack_public_path__ + "static/media/truck.6aa53a05.svg";